<template>
  <div>
    <div v-if="!contentAvailable && !contentError" class="spinner-padding">
      <pvd-spinner id="content-spinner" pvd-size="large"></pvd-spinner>
    </div>
    <div v-if="contentAvailable"><ContentComponent></ContentComponent></div>
    <div v-if="contentError" class="error-padding">
      <pvd-alert v-if="contentError" id="content-error-id" pvd-disable-a11y-attributes>
        {{ clientConstants.CONTENT_UNAVAILABLE_ERROR }}
      </pvd-alert>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import ContentComponent from './../components/Content.vue';
import store from './../store/store';

export default defineComponent({
  name: 'EducationView',
  components: { ContentComponent },
  computed: {
    contentAvailable(): boolean {
      return this.store.contentLoaded;
    },
    contentError(): boolean {
      return this.store.contentError;
    }
  },
  data: () => {
    return {
      clientConstants: ClientConstants,
      store: reactive(store)
    };
  }
});
</script>
<style scoped>
.spinner-padding {
  padding-top: 15rem;
  padding-bottom: 15rem;
}
.error-padding {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
</style>
